<template>
  <div class="page_israGud">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="flex aic" style="padding-left: 15px;">
            <div class="flname" style="margin-right: 10px;">主体名称 </div>
            <el-select v-model="listQuery.BusinessId" placeholder="" size="small" clearable @change="seachHandle">
              <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="item.Id"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>文档管理</el-breadcrumb-item>
          <el-breadcrumb-item>三体系认证</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="案例管理" name="/successCaseSet"></el-tab-pane>
          <el-tab-pane label="合同模板管理" name="/contractTemplateSet"></el-tab-pane>
          <el-tab-pane label="报价体系" name="/quotationGuiSet"></el-tab-pane>
          <el-tab-pane label="三体系认证" name="/threeSystem"></el-tab-pane>
          <el-tab-pane label="公司介绍" name="/companyProfileSet"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;">
          <el-button type="success" size="small" @click="addSys">&nbsp;新增</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" style="width:861px;" v-loading="loading">
          <el-table-column prop="date" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="FileType" label="名称" width="260" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CompanyName" label="主体名称" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="UpdataTime" label="更新时间" width="160" align="center">
            <template slot-scope="scope">
              {{ scope.row.UpdataTime.replace('T',' ') }}
            </template>
          </el-table-column>
          <el-table-column prop="Url" label="附件" width="100" align="center">
            <template slot-scope="scope">
              <div class="info_item_sys cp" v-if="scope.row.Url" @click="down(scope.row.Url)">下载</div>
              <div v-else>暂无附件</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作" width="150" align="center">
            <template slot-scope="scope">
              <div class="flex" style="justify-content: center;">
                <el-upload class="table_upload" action="" :on-change="(file, fileList) => {handleChangeUpload(file, fileList, scope.$index)}" :auto-upload="false" :show-file-list="false" :multiple="false">
                  <div class="info_item_sys">{{ scope.row.Url ? '更新' : '上传' }}</div>
                </el-upload>
                <span class="info_item_sys cp" style="margin-left: 10px;" @click="delUrl(scope.row)" v-if="scope.row.Url">删除附件</span>
                <span class="info_item_sys cp" style="margin-left: 10px;" @click="del(scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
      <el-dialog title="新增体系" :visible.sync="showAddSys" width="500px">
        <el-form :model="formData" ref="caseForm" label-width="80px">
          <el-form-item label="名称" prop="FileType">
            <el-input v-model="formData.FileType" style="width: 221px;"></el-input>
          </el-form-item>
          <el-form-item label="签约主体" prop="CompanyName">
            <el-select v-model="formData.CompanyName" placeholder="" clearable filterable value-key="Id" @change="changeCom">
              <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showAddSys = false" size="small">取消</el-button>
          <el-button type="primary" v-preventReClick size="small" @click="confirmAdd">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        tableData: [],
        totalCount: 0,
        listQuery: {
          BusinessId: '',
          BusiType: '1',
          pageNum: 1,
          pageSize: "10"
        },
        headPath: this.$store.state.EMP.docPath,
        activeName: '/threeSystem',
        legList: [], //法务主体列表
        showAddSys: false,
        formData:{
          Id:'',
          BusiType: '1',
          BusinessId:'',//主体ID
          CompanyName:'',//主体名称
          FileType:'',//名称
          Url:''
        },
        loading:false
      };
    },
    created() {
      this.getfilelist();
      this.getlegalsubjectlist()
    },
    methods: {
      handleClick() {
        this.$router.push({
          path: this.activeName
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        this.loading = true;
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
            this.loading = false;
          } else {
            this.$message.error('系统出错')
            this.legList = [];
            this.loading = false;
          }
        })
      },
      //获取三体系列表
      getfilelist() {
        xz.getfilelist(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0
          }
        })
      },
      seachHandle() {
        this.listQuery.pageNum = 1;
        this.getfilelist();
      },
      currentChange(val) {
        this.listQuery.pageNum = `${val}`;
        this.getfilelist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getfilelist();
      },
      down(url) {
        let d = url.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      handleChangeUpload(file, fileList, index) {
        console.log(file, index)
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.raw.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.tableData[index].Url = res;
            xz.updatefilemanage(this.tableData[index]).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！')
              } else {
                this.$message.error('系统出错')
              }
            })
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      del(row) {
        this.$set(row, 'IsDeleted', 1)
        xz.updatefilemanage(row).then(res => {
          if (res.status == 'ok') {
            this.seachHandle();
            this.$message.success('删除成功！')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      delUrl(row) {
        this.$set(row, 'Url', '')
        xz.updatefilemanage(row).then(res => {
          if (res.status == 'ok') {
            this.seachHandle();
            this.$message.success('附件删除成功！')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      addSys() {
        this.showAddSys = true;
      },
      //选择主体
      changeCom(val){
        this.formData.CompanyName = val.CompanyName;
        this.formData.BusinessId = val.Id;
      },
      //确认新增
      confirmAdd(){
        xz.updatefilemanage(this.formData).then(res=>{
          if(res.status=='ok'){
            this.seachHandle();
            this.$message.success('保存成功！')
          }else{
            this.seachHandle();
            this.$message.error('系统出错')
          }
          this.showAddSys = false
        })
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }
</style>
<style>

</style>